import React from 'react';
import { ModalsKeys } from 'global';
import { useQuery } from '@apollo/client';
import { Add } from '@mui/icons-material';
import { useModal } from 'hooks/useModal';
import { useForm, useWatch } from 'react-hook-form';
import { InputField, SelectField } from 'components/form';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { AdminDashboardList } from './AdminDashboardList';
import { SELECT_OPTION_INTEGRATION_TYPE } from '../../constants';
import { AdminDashboardListResponse, adminExternalDashboardsApi } from '../../api';

export const DashboardManagementCard = () => {
  const { handleOpen } = useModal(ModalsKeys.ExternalDashboardDialog);

  const { control } = useForm<{ filters: { search: string; type: string } }>({
    defaultValues: { filters: { search: '', type: 'all' } },
  });

  const filters = useWatch({ control, name: 'filters' });

  const { data, loading } = useQuery<AdminDashboardListResponse>(adminExternalDashboardsApi.getAdminDashboardList, {
    variables: {
      input: {
        filters: {
          ...(filters?.search ? { search: filters.search } : {}),
          ...(filters.type !== 'all' ? { type: filters.type } : {}),
        },
      },
    },
  });

  return (
    <CardContainer>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography component="span" variant="h6">
          List
        </Typography>

        <Box>
          <Button startIcon={<Add />} onClick={() => handleOpen()}>
            Add new
          </Button>
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" gap="1rem">
        <InputField control={control} name="filters.search" label="Search" inputProps={{ variant: 'outlined' }} />

        <SelectField
          label="Type"
          control={control}
          variant="outlined"
          name="filters.type"
          options={[...SELECT_OPTION_INTEGRATION_TYPE, { label: 'All', value: 'all' }]}
        />
      </Stack>

      <RenderWithFallback
        isLoading={loading}
        fallBack={
          <Stack height="100%" width="100%" alignItems="center" justifyContent="center">
            <CircularProgress />
          </Stack>
        }
      >
        <AdminDashboardList dashboardOptionList={data?.externalDashboards?.result?.list ?? []} />
      </RenderWithFallback>
    </CardContainer>
  );
};
